/*
 * Protection anti-robot du formulaire de contact.
 *
 * Deux garde-fous, tous deux cote client :
 *   1. Honeypot : un champ invisible que seul un robot remplit.
 *   2. Question mathematique generee en JS a l'affichage.
 *
 * Le bloc captcha est rendu masque (attribut `hidden`) et c'est ce script qui
 * le revele : un visiteur sans JavaScript n'est donc jamais bloque par une
 * question a laquelle il ne peut pas repondre.
 *
 * Ni le champ reponse ni le honeypot n'ont d'attribut `name` : ils ne sont pas
 * envoyes a Shopify et n'apparaissent donc jamais dans l'e-mail recu.
 *
 * Rappel : une verification cote client ne remplace pas le reCAPTCHA natif de
 * Shopify (Boutique en ligne > Preferences > Protection contre le spam), seul
 * a etre valide cote serveur.
 */
(function () {
  if (window.__customContactCaptcha) return;
  window.__customContactCaptcha = true;

  var MESSAGE_EMPTY = 'Please answer the anti-robot question.';
  var MESSAGE_WRONG = 'Wrong answer — a new question has been generated.';

  function randomDigit() {
    return Math.floor(Math.random() * 9) + 1;
  }

  function setupCaptcha(wrapper) {
    var input = wrapper.querySelector('[data-captcha-input]');
    var questionEl = wrapper.querySelector('[data-captcha-question]');
    var errorEl = wrapper.querySelector('[data-captcha-error]');
    if (!input || !questionEl) return null;

    // La reponse attendue reste dans la fermeture, jamais dans le DOM.
    var expected = 0;

    function newChallenge() {
      var a = randomDigit();
      var b = randomDigit();
      expected = a + b;
      questionEl.textContent = a + ' + ' + b + ' = ?';
      input.value = '';
    }

    function clearError() {
      if (errorEl) errorEl.textContent = '';
      input.removeAttribute('aria-invalid');
    }

    function showError(message) {
      if (errorEl) errorEl.textContent = message;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }

    input.addEventListener('input', clearError);
    newChallenge();
    wrapper.hidden = false;

    return function validate() {
      var value = input.value.trim();
      if (value === '') {
        showError(MESSAGE_EMPTY);
        return false;
      }
      if (parseInt(value, 10) !== expected) {
        newChallenge();
        showError(MESSAGE_WRONG);
        return false;
      }
      clearError();
      return true;
    };
  }

  function setupForm(form) {
    if (form.dataset.contactGuardReady === 'true') return;

    var honeypot = form.querySelector('[data-contact-honeypot]');
    var wrapper = form.querySelector('[data-contact-captcha]');
    var validateCaptcha = wrapper ? setupCaptcha(wrapper) : null;
    if (!honeypot && !validateCaptcha) return;

    form.dataset.contactGuardReady = 'true';

    function block(event) {
      event.preventDefault();
      // Coupe la propagation : sans cela, la protection anti-spam de Shopify
      // peut afficher son defi hCaptcha alors que l'envoi est deja refuse ici.
      event.stopImmediatePropagation();
    }

    // Phase de capture : on passe avant les autres ecouteurs quand c'est possible.
    form.addEventListener(
      'submit',
      function (event) {
        // Honeypot rempli : on abandonne en silence, inutile de renseigner le robot.
        if (honeypot && honeypot.value.trim() !== '') {
          block(event);
          return;
        }
        if (validateCaptcha && !validateCaptcha()) {
          block(event);
        }
      },
      true
    );
  }

  function init() {
    var forms = document.querySelectorAll('.contact-form__form');
    for (var i = 0; i < forms.length; i++) setupForm(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // L'editeur de theme re-rend la section : on reinitialise le nouveau formulaire.
  document.addEventListener('shopify:section:load', init);
})();
